import { AuthProvider, useAuth } from '../auth/AuthProvider.tsx';
import { PlayerProvider, usePlayer } from '../player/PlayerProvider.tsx';
import { DiagnosticsScreen } from '../screens/DiagnosticsScreen.tsx';
import { AdminScreen } from '../admin/AdminScreen.tsx';
import { HomeScreen } from '../kids/HomeScreen.tsx';
import { GroupScreen } from '../kids/GroupScreen.tsx';
import { PlayerScreen } from '../kids/PlayerScreen.tsx';
import { GrownUpScreen } from '../kids/GrownUpScreen.tsx';
import { ReloadPrompt } from './ReloadPrompt.tsx';
import { matchRoute, useHashRoute } from './router.ts';

export function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <Routes />
        <ReloadPrompt />
      </PlayerProvider>
    </AuthProvider>
  );
}

function Routes() {
  const route = useHashRoute();
  const { status } = useAuth();
  const { needsGrownUp, dismissGrownUp } = usePlayer();

  const isAdminRoute = route.startsWith('/eltern');

  // Ohne Anmeldung fuehrt kein Weg an der Einrichtung vorbei.
  if (status !== 'loggedIn' && status !== 'initializing') {
    return <DiagnosticsScreen />;
  }

  if (route === '/eltern/diagnose') return <DiagnosticsScreen />;
  if (route === '/eltern') return <AdminScreen />;

  // Der Erwachsenen-Bildschirm ersetzt jede Fehlermeldung im Kinderbereich.
  if (needsGrownUp && !isAdminRoute) {
    return <GrownUpScreen onRetry={dismissGrownUp} />;
  }

  const groupMatch = matchRoute(route, '/gruppe/:id');
  if (groupMatch?.['id']) return <GroupScreen groupId={groupMatch['id']} />;

  const playerMatch = matchRoute(route, '/spielt/:id');
  // `key` ist wichtig: ohne ihn behaelt React die Komponente beim direkten
  // Wechsel von einer Folge zur naechsten bei und startet die neue nie.
  if (playerMatch?.['id']) {
    return <PlayerScreen key={playerMatch['id']} itemId={playerMatch['id']} />;
  }

  return <HomeScreen />;
}
